var React = require('react');

function FlagNr (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 423.724H8.828A8.829 8.829 0 010 414.896V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.792a8.83 8.83 0 01-8.829 8.828z","fill":"#41479b","key":0}),React.createElement("path",{"fill":"#ffe15a","d":"M0 238.34h512v35.31H0z","key":1}),React.createElement("path",{"fill":"#f5f5f5","d":"M119.172 308.965l5.141 20.54 14.721-15.218-5.817 20.358 20.357-5.818-15.216 14.723 20.538 5.139-20.538 5.141 15.216 14.721-20.357-5.817 5.817 20.358-14.721-15.217-5.141 20.539-5.141-20.539-14.721 15.217 5.818-20.358-20.358 5.817 15.217-14.721-20.539-5.141 20.539-5.139-15.217-14.723 20.358 5.818-5.818-20.358 14.721 15.218z","key":2})]);
}

FlagNr.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagNr;

FlagNr.default = FlagNr;
